<style lang="less" scoped>
.compare-box {
  padding: 15px;
  border-radius: 10px;
  border: 2px dashed #eee;
  margin-top: 20px;
}
.preview-list {
  display: flex;
  flex-direction: row;
  /*> *:nth-child(2){
      margin-left: 25px;
    }*/
  > * {
    flex: 1;
    /deep/.preview-box {
      margin: 20px auto 0 !important;
    }
  }

  .preview-title {
    margin-bottom: 10px;
    text-align: center;
    width: 100%;
  }
}
</style>

<template>
  <div style="display: flex; flex-direction: column;height: 100%">
    <div class="sub-title">
      <i class="iconfont icon-zaixianduibiweijihuo"></i> 人脸视频对比
    </div>
    <div class="main-shadow-box">
      <div v-show="!imagefiles.length" class="tip">
        <i class="el-icon-sunrise-1"></i> 请选择图片
      </div>
      <div v-show="!videofiles.length" class="tip">
        <i class="el-icon-sunrise-1"></i> 请选择视频
      </div>

      <image-select @select="selectImageFile"></image-select>&nbsp;&nbsp;&nbsp;
      <video-select @select="selectVideoFile"></video-select>

      <div class="compare-box" v-show="imagefiles.length || videofiles.length">
        <div class="preview-list">
          <image-preview :file="imagefiles[0]">
            <div class="preview-title">图片</div>
          </image-preview>
          <video-preview :file="videofiles[0]">
            <div class="preview-title">视频</div>
          </video-preview>
        </div>
        <div style="margin-top: 30px; text-align: center;">
          <el-button @click="reset">重置</el-button>
          <el-button
            type="primary"
            :disabled="imagefiles.length < 1 || videofiles.length < 1"
            @click="handleCompare"
            :loading="buttonLoading"
            :title="(imagefiles.length < 1 || videofiles.length < 1)?'需选择一张图片和一个视频':''"
          >对比</el-button>
          <br />
        </div>
      </div>
      <div v-if="message" style="text-align: center; margin-top: 20px;">{{message}}</div>
    </div>
  </div>
</template>
<script>
  import ImagePreview from "@/components/image-preview.vue";
  import VideoPreview from "@/components/video-preview.vue";
  import ImageSelect from "@/components/image-select.vue";
  import VideoSelect from "@/components/video-select.vue";

  export default {
    components: {
      ImageSelect,
      VideoPreview,
      VideoSelect,
      ImagePreview
    },
    data() {
      return {
        imagefiles: [],
        videofiles: [],
        message: "",
        buttonLoading: false
      };
    },
    methods: {
      reset() {
        this.imagefiles = [];
        this.videofiles = [];
        this.message = "";
      },
      imagereset() {
        this.imagefiles = [];
        this.message = "";
      },
      videoreset() {
        this.videofiles = [];
        this.message = "";
      },
      selectImageFile(files) {
        if (files.length + this.imagefiles.length > 1) {
          this.imagereset();
        }
        this.imagefiles = this.imagefiles.concat(files).slice(0, 1);
      },
      selectVideoFile(files) {
        if (files.length + this.videofiles.length > 1) {
          this.videoreset();
        }
        this.videofiles = this.videofiles.concat(files).slice(0, 1);
      },
      handleCompare() {
        this.buttonLoading = true;
        this.compare();
      },
      async compare() {
        try {
          let res = await this.$request(
            this.$api.face1vsV.compare({
              image: this.imagefiles[0],
              video: this.videofiles[0]
            })
          );
          this.message = "对比结果: " + ((res.compareresult == true) ? "对比通过" : "未通过");
        } catch ({ response }) {
            this.message = response.data.msg;
        } finally {
            this.buttonLoading = false
        }
      }
    }
  };
</script>

